import { render, staticRenderFns } from "./PwaPopup.vue?vue&type=template&id=54dc169a&"
import script from "./PwaPopup.vue?vue&type=script&lang=js&"
export * from "./PwaPopup.vue?vue&type=script&lang=js&"
import style0 from "./PwaPopup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dc169a')) {
      api.createRecord('54dc169a', component.options)
    } else {
      api.reload('54dc169a', component.options)
    }
    module.hot.accept("./PwaPopup.vue?vue&type=template&id=54dc169a&", function () {
      api.rerender('54dc169a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/PwaPopup.vue"
export default component.exports